import React from 'react';
import FeaturedImage from '../FeaturedImage';

function staff(props) {
  const {
    post,
    postType,

    replaceSelected
  } = props;

  let featuredImage;
  let role;

  let image = post.hasOwnProperty('featured_image') && post.featured_image ? post.featured_image : false;
  image = !image && post.hasOwnProperty('featured_image_srcset') && post.featured_image_srcset ? post.featured_image_srcset : image;

  if (image) {
    featuredImage = <a href={post.link} className="staff-card__image">
      <FeaturedImage
        imageSize={'staff-card'}
        image={image}
        srcset={image}
      ></FeaturedImage>
    </a>
  } else {
    featuredImage = <a href={post.link} className="staff-card__image"></a>
  }

  if (post.hasOwnProperty('acf_data') && post.acf_data.role) {
    role = <p className="staff-card__role">{post.acf_data.role}</p>;
  }

  return (
    <article id={`${postType}-${post.id}`} className="staff-card">
      {featuredImage}

      <div className="staff-card__content">
        <h4 className="staff-card__title"><a href={post.link} dangerouslySetInnerHTML={{__html: post.title.rendered}}></a></h4>

        {role}
      </div>
    </article>
  );
}

export default staff;